module.exports = __webpack_public_path__ + "img/bg-buildings.jpg?35e89fe107c373f202235dd232d5c6de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-buildings.jpg
// module id = 1250
// module chunks = 1